module.exports = __webpack_public_path__ + "28c855337c34273d74902db6fa9e3fd5.png";